import { render, staticRenderFns } from "./QSkeleton.vue?vue&type=template&id=18de4e34&scoped=true&"
import script from "./QSkeleton.vue?vue&type=script&lang=ts&"
export * from "./QSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./QSkeleton.vue?vue&type=style&index=0&id=18de4e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18de4e34",
  null
  
)

export default component.exports